export default __webpack_public_path__ + "static/media/lib.f4d5d901.jpeg";